import styled from '@emotion/styled';

type P = {
  title: string;
};

const GrayBanner = ({ title }: P) => {
  return <StyledBox>{title}</StyledBox>;
};
export default GrayBanner;

const StyledBox = styled.div`
  padding: 2px 4px;
  background-color: #f3f5f6;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;
  border-radius: 2px;
`;
